import { __decorate } from "tslib";
import { Component, Emit, ModelSync, Vue } from "vue-property-decorator";
let ChoiceTypeDescriptionEdit = class ChoiceTypeDescriptionEdit extends Vue {
    editEnabled = false;
    error = "";
    valueSync;
    setEditMode(value) {
        this.editEnabled = value;
    }
    onKeyDown(event) {
        if (["Enter", "Esc", "Escape"].indexOf(event.key) > -1) {
            this.closeEditMode();
        }
    }
    closeEditMode() {
        if (this.editEnabled) {
            this.validate();
            this.setEditMode(false);
        }
    }
    showEditMode() {
        this.setEditMode(true);
    }
    onDelete() {
        return true;
    }
    validate() {
        if (!this.valueSync) {
            this.error = "Description is required";
            return [this.error];
        }
        else {
            this.error = '';
        }
        return [];
    }
};
__decorate([
    ModelSync('value', 'change', { type: String, default: null })
], ChoiceTypeDescriptionEdit.prototype, "valueSync", void 0);
__decorate([
    Emit('delete')
], ChoiceTypeDescriptionEdit.prototype, "onDelete", null);
ChoiceTypeDescriptionEdit = __decorate([
    Component({
        components: {},
    })
], ChoiceTypeDescriptionEdit);
export default ChoiceTypeDescriptionEdit;
